import { render, staticRenderFns } from "./VRadio.vue?vue&type=template&id=49d47ad7&scoped=true"
import script from "./VRadio.vue?vue&type=script&lang=js"
export * from "./VRadio.vue?vue&type=script&lang=js"
import style0 from "./VRadio.vue?vue&type=style&index=0&id=49d47ad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d47ad7",
  null
  
)

export default component.exports